import { render, staticRenderFns } from "./InboundDetails.vue?vue&type=template&id=6bca576d&"
import script from "./InboundDetails.vue?vue&type=script&lang=js&"
export * from "./InboundDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports